'use client'
import * as React from 'react'
import { useTranslations, useLocale } from 'next-intl'
// eslint-disable-next-line
import { useRouter, useSearchParams } from 'next/navigation'
import { Select } from '@repo/web-ui/components/select/select'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'

interface SortProps {
  categoryPath: string
  pathname: string
  translationNamespace: string
}

function SortInner({ categoryPath, pathname, translationNamespace }: SortProps) {
  const locale = useLocale()
  const t = useTranslations(translationNamespace)
  // react-doctor-disable-next-line react-doctor/react-compiler-destructure-method, react-doctor/nextjs-no-use-search-params-without-suspense
  const searchParams = useSearchParams()
  const { push } = useRouter()
  // react-doctor-disable-next-line react-doctor/react-compiler-destructure-method
  const sortDirection: SortType = (searchParams.get('orderby') || 'popularity') as SortType
  const items = [
    { value: 'popularity', label: t('sort.popularity') },
    { value: 'date', label: t('sort.date') },
  ]

  return (
    <Select
      value={sortDirection}
      onValueChange={value => {
        const updatedSearchParams = new URLSearchParams(searchParams.toString())
        updatedSearchParams.set('orderby', value)

        push(
          addOrReplaceLocaleInUrl(
            `${categoryPath}${pathname}?${updatedSearchParams.toString()}`,
            locale,
          ),
          {
            scroll: false,
          },
        )
      }}
      items={items}
    />
  )
}

export function Sort(props: SortProps) {
  return (
    <React.Suspense>
      <SortInner {...props} />
    </React.Suspense>
  )
}

export type SortType =
  | 'date'
  | 'popularity'
  | 'new'
  | 'old'
  | 'price_low'
  | 'price_high'
  | 'expiring'
